import storageValue from "./misc/localStorageDriver";
import {getRoles} from "./components/authentication/login";

export const commercial = true;
export const contextKey ='.tr-data-production-context'
export const localContextKey = '.tr-local-analytics-context'

export const contextSwitcherRoles = ['admin', 'maintainer', 'developer']

function roles() {
    try {
        const r = getRoles();
        return Array.isArray(r) ? r : [];
    } catch (e) {
        return [];
    }
}

export function canSwitchContext() {
    return roles().some(r => contextSwitcherRoles.includes(r));
}

export function hasProductionAccess() {
    return canSwitchContext() || roles().includes("production-data");
}

export function getDataContext() {
    if (canSwitchContext()) return new storageValue(contextKey).read(false)
    // Sin interruptor el ambiente es fijo: se ignora localStorage a proposito.
    return roles().includes("production-data")
}
export function setDataContext(value) {return new storageValue(contextKey).save(value)}
export function getDataContextHeader() {return getDataContext() ? "production": "staging"}

export function getLocalContext(key, defaultValue) {return new storageValue(key).read(defaultValue)}
export function setLocalContext(key, value) {return new storageValue(key).save(value)}
export function getLocalContextHeader(key) {return new storageValue(key).read(false) ? "production": "staging"}